import SectionWithSlider from "@components/global/SectionWithSlider"
import { useScrollAnim } from "src/hooks/hooks"
import { convertHtmlToReact, convertJson, imgUrl } from "src/mixins"

function ProductsServicesMore({ data, locale }) {
  const [trigger, anim] = useScrollAnim()
  return (
    <SectionWithSlider
      sectionName="sc-products-services-more"
      data={convertJson(data.items)?.map((item) => ({
        title: item[`title_${locale}`],
        text: convertHtmlToReact(item[`description_${locale}`]),
        img: imgUrl(item.image),
        linkCard: item?.link_url,
      }))}
      title={data && data[`title_${locale}`]}
      text={convertHtmlToReact(data[`description_${locale}`])}
      textClassName="text-dark"
      slidesPerViewMobile={1.2}
      slidesPerViewDesktop={1.6}
      hasArrow
      linkCardWithButton
    />
  )
}

export default ProductsServicesMore
